import { ApolloError } from '@apollo/client';

export const logError = (error: Error | ApolloError) => {
  const shouldLogErrors = process.env.REACT_APP_ENVIRONMENT === 'production';
  if (!shouldLogErrors) {
    return;
  }
  console.log('[Error]: ', JSON.stringify(error));
};
